const segmentTypes = {
  HIKING: 'hiking',
  WALKING: 'walking',
  SHUTTLE: 'shuttle',
};

export default segmentTypes;
